import typeApi from '@/api/type.api'

export const typeService = (function () {
  'use strict'

  /**
   * Para obtener el arreglo de tipos de cosas para los selectores del ABM
   */
  async function getAllForSelector() {
    try {
        const response = await typeApi.getAllForSelector()
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  /**
   * Devuelve los tipos de una empresa y un tipo de equipo en particular
   */
  async function getAllForSelectorByEnterpriseIdAndActivityId(enterpriseId, activityId) {
    try {
        const response = await typeApi.getAllForSelectorByEnterpriseIdAndActivityId(enterpriseId, activityId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  return {
    getAllForSelector,
    getAllForSelectorByEnterpriseIdAndActivityId,
  }

})()
